import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../shared/services/alert.service';
import {Location} from '@angular/common';
import {EshopService} from '../../shared/services/eshop.service';
import {StorageService} from '../../shared/services/storage.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from '../../shared/services/global.service';

@Component({
  selector: 'app-eshop',
  templateUrl: './eshop.component.html',
  styleUrls: ['./eshop.component.scss']
})
export class EshopComponent implements OnInit {
  stockists: any = [];
  selectedStockist: any;
  productCount: any = 0;
  cartItems: any = [];

  constructor(private router: Router,
              private fb: FormBuilder,
              public activatedRoute: ActivatedRoute,
              private alertService: AlertService,
              private _location: Location,
              private eshopService: EshopService,
              public modalService: NgbModal,
              public globalService: GlobalService) {
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.cartItems = StorageService.getItem('cartItems');
    this.getStockist();
  }

  getStockist(params: any = {}) {
    this.eshopService.getStockist(params).subscribe(data => {
      this.stockists = data;
      this.selectedStockist = undefined;
      this.triggerScroll();
    });
  }

  getProducts(event) {
    this.selectedStockist = (event && event.target.value) ? event.target.value : undefined;
    if (this.selectedStockist) {
      this.eshopService.getProducts({'puc': this.selectedStockist}).subscribe(data => {
        this.productCount = (data && data.length) ? data.length : 0;
        this.triggerScroll();
      });
    }
  }

  proceed(content) {
    if (this.selectedStockist) {
      if (this.cartItems && this.cartItems.length > 0) {
        let alreadyStoredStockist = StorageService.getItem('selectedStockist');
        if (parseInt(alreadyStoredStockist.user_id) !== parseInt(this.selectedStockist)) {
          this.modalService.open(content);
        } else {
          this.showProducts();
        }
      } else {
        this.showProducts();
      }
    } else {
      this.alertService.showErrors('Something went wrong, please refresh and try again');
    }
  }

  showProducts() {
    if (this.stockists && this.stockists.length > 0) {
      this.stockists.forEach(stockist => {
        if (parseInt(stockist.user_id) === parseInt(this.selectedStockist)) {
          StorageService.setItem('selectedStockist', stockist);
        }
      });
    }
    this.router.navigateByUrl('/users/eshop/products')
  }

  yes() {
    StorageService.removeItem('cartItems');
    if (this.stockists && this.stockists.length > 0) {
      this.stockists.forEach(stockist => {
        if (parseInt(stockist.user_id) === parseInt(this.selectedStockist)) {
          StorageService.setItem('selectedStockist', stockist);
        }
      });
    }
    this.globalService.changeCartCount([]);
    this.modalService.dismissAll('');
    this.router.navigateByUrl('/users/eshop/products')
  }

  back() {
    this._location.back();
  }

  navigateTo(url) {
    this.router.navigateByUrl(url);
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }
}
